// api/axios.js
import axios from "axios";

const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

api.interceptors.request.use(config => {
  const token = sessionStorage.getItem('previewToken');
  if (token) {
    config.headers['X-Preview-Token'] = token;
  }
  return config;
});

let isRefreshing = false;
let queue = [];

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      if (originalRequest.url.includes("/auth/token/refresh") || originalRequest.url.includes("/auth/me")) {
        return Promise.reject(error);
      }


      if (!isRefreshing) {
        isRefreshing = true;

        try {
          await axios.post("/auth/token/refresh/", {}, {
            withCredentials: true,
          });

          queue.forEach((p) => p.resolve());
          queue = [];
          return api(originalRequest);
        } catch (err) {
          queue.forEach((p) => p.reject(err));
          queue = [];
          return Promise.reject(err);
        } finally {
          isRefreshing = false;
        }
      }

      return new Promise((resolve, reject) => {
        queue.push({
          resolve: () => resolve(api(originalRequest)),
          reject,
        });
      });
    }

    return Promise.reject(error);
  }
);

export default api;
